import { InventoryLocationBuilding, InventoryMeter, Manufacturer } from '@enmon/commons/lib/tools';
import { SerializedMeter } from '@enmon/commons/lib/enmon';
import { Commodity } from '@enmon/commons/lib/shared';
import type { InventorizeMeterStore } from '../../useStore';

export interface MemoizedValues {
  buildingFloor?: SerializedMeter['buildingFloor'];
  lat?: number;
  lng?: number;
  locationBuilding?: InventoryLocationBuilding['id'] | 'empty';
  manufacturer?: Manufacturer['id'];
  meterOwner?: SerializedMeter['owner'];
  meterTenant?: InventoryMeter['tenant'];
  commodity?: Commodity;
  lorawanRssi?: number;
  nbiotRssi?: number;
}

export const getMemoizedValues = (state: InventorizeMeterStore): MemoizedValues => {
  const {
    buildingFloor,
    lat,
    lng,
    locationBuilding,
    manufacturer,
    commodity,
    meterOwner,
    lorawanRssi,
    nbiotRssi,
    meterTenant,
  } = state;
  return {
    buildingFloor,
    lat,
    lng,
    locationBuilding,
    manufacturer,
    commodity,
    meterOwner,
    lorawanRssi,
    nbiotRssi,
    meterTenant,
  };
};
